import { useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { AddUserFormFields } from "./AddUserFormFields";
import { useUserCreation } from "@/hooks/useUserCreation";

interface AddUserDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onSuccess: () => void;
}

export const AddUserDialog = ({
  open,
  onOpenChange,
  onSuccess,
}: AddUserDialogProps) => {
  const [email, setEmail] = useState("");
  const [fullName, setFullName] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const { createUser, isLoading } = useUserCreation({ onSuccess });

  const resetForm = () => {
    setEmail("");
    setFullName("");
    setPassword("");
    setConfirmPassword("");
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    try {
      if (!email || !fullName || !password || !confirmPassword) {
        toast.error("Veuillez remplir tous les champs");
        return;
      }

      if (password !== confirmPassword) {
        toast.error("Les mots de passe ne correspondent pas");
        return;
      }

      if (password.length < 6) {
        toast.error("Le mot de passe doit contenir au moins 6 caractères");
        return;
      }

      const success = await createUser({ email, password, fullName });
      
      if (success) {
        resetForm();
        onOpenChange(false);
      }
    } catch (error: any) {
      console.error('Error in form submission:', error);
      toast.error("Une erreur est survenue lors de l'ajout de l'utilisateur");
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Ajouter un utilisateur</DialogTitle>
          <DialogDescription>
            Ajoutez un nouvel utilisateur à votre compte. Les identifiants seront affichés après la création.
          </DialogDescription>
        </DialogHeader>
        <form onSubmit={handleSubmit} className="space-y-4">
          <AddUserFormFields
            fullName={fullName}
            setFullName={setFullName}
            email={email}
            setEmail={setEmail}
            password={password}
            setPassword={setPassword}
            confirmPassword={confirmPassword}
            setConfirmPassword={setConfirmPassword}
          />
          <Button type="submit" className="w-full" disabled={isLoading}>
            {isLoading ? "Ajout en cours..." : "Ajouter l'utilisateur"}
          </Button>
        </form>
      </DialogContent>
    </Dialog>
  );
};